'use client';

import { useMutation } from '@tanstack/react-query';

import { APP_ROUTES } from '@/shared/constants/navigation';
import { resetMixpanel } from '@/shared/utils/mixpanel-utils';
import { clearLocalStorage, clearSessionStorage } from '@/shared/utils/storage';
import { tabStorage } from '@/shared/utils/tab-storage';

export function LogoutLink({ className }: { className?: string }) {
	const { mutate: logout, isPending } = useMutation({
		mutationFn: () => fetch('/logout', { method: 'POST' }),
		onSuccess: () => {
			tabStorage.clear();
			resetMixpanel();
			clearSessionStorage();
			clearLocalStorage();
			window.location.href = APP_ROUTES.LOGIN;
		},
	});

	return (
		<button
			type="button"
			onClick={() => logout()}
			disabled={isPending}
			className={className ?? 'text-sm text-secondary hover:text-primary'}
		>
			Log out
		</button>
	);
}
